import { esSlideshowPalettes } from "../../../../Posts/05-tematicas/06-diapositivas/slideshowPalettes.js";
import * as React from 'react';
export default {
  esSlideshowPalettes,
  React
};